import VehicleSearch, {
  type VehicleSearchProps,
} from '@allesauto/core/vehicleSearch';
import React from 'react';

import { useOnChange } from './useOnChange';
import { useOnSubmit } from './useOnSubmit';

export type VehicleSearchFormProps = Omit<VehicleSearchProps, 'onSubmit'>;

/**
 * Wrapper around the @allesauto/core VehicleSearch with a next.js-specific submit handler
 */
const VehicleSearchForm = (props: VehicleSearchFormProps) => (
  <VehicleSearch {...props} onChange={useOnChange()} onSubmit={useOnSubmit()} />
);

export default VehicleSearchForm;
